var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.16 472.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.47,308.61l-.39-.34a11.41,11.41,0,0,0-1.62-1.39Q479.1,203.8,359.71,100.76c-6.1-5.27-13.69-5.27-19.79,0Q219.53,204.68,99.17,308.62c-9.52,8.21-1.66,23.9,9.9,23.9h48.61V554.9a14.13,14.13,0,0,0,14,14H308.57a14.13,14.13,0,0,0,14-14V432h63.26V554.9a14.13,14.13,0,0,0,14,14H536.72a14.13,14.13,0,0,0,14-14V332.52h39.86a12.67,12.67,0,0,0,11.95-7.19c3.5-4.91,3.92-11.56-2-16.71ZM553,304.51H536.7a14.13,14.13,0,0,0-14,14V540.89H413.81V418a14.13,14.13,0,0,0-14-14H308.56a14.13,14.13,0,0,0-14,14V540.89H185.67V318.51a14.13,14.13,0,0,0-14-14h-25L349.81,129.1Q451.39,216.81,553,304.51Z",
    transform: "translate(-94.92 -96.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.25fba1dd02e330bdbaee8d08398bfe3b.svg";
export { ForwardRef as ReactComponent };